/**
 * Sandbox policy for the plugin iframe — the SINGLE source of truth shared by
 * every surface that mounts a plugin (the production renderer plus the builder
 * and dev preview panes). One constant guarantees a plugin behaves identically
 * in preview and in production; drift would let a capability appear on one
 * surface and not another.
 *
 * Tokens (order is cosmetic — the attribute is a set):
 *   - allow-scripts   — plugins are JS apps.
 *   - allow-forms     — plugins submit forms.
 *   - allow-downloads — plugins can trigger downloads (exports, generated files).
 *   - allow-popups + allow-popups-to-escape-sandbox — a plugin may open an
 *     external link in a new tab (e.g. `window.open(url, '_blank')` behind a
 *     button click). Without allow-popups the browser silently no-ops the call;
 *     allow-popups-to-escape-sandbox makes the opened tab a normal browsing
 *     context so the destination (YouTube, docs, …) isn't itself sandboxed and
 *     broken.
 *
 * SECURITY (accepted trade-off): with allow-popups a plugin can navigate the
 * user to ANY external URL with no host mediation and no confirmation — a
 * native `window.open` never reaches the host, so the platform cannot
 * gate/allowlist it at runtime. Outbound navigation is instead policed by the
 * plugin security-review pipeline (services/plugin-review-service), whose AI
 * analyzer is primed to scrutinize `window.open` targets.
 *
 * Deliberately ABSENT — never add either to a production surface:
 *   - allow-same-origin      → would let a plugin escape its opaque origin and
 *                              read/write cross-frame (defeats isolation).
 *   - allow-top-navigation*  → would let a plugin hijack the whole Fias tab.
 *
 * The dev harness (packages/plugin-dev-harness/.../harness.html) intentionally
 * runs a LOOSER sandbox (it adds allow-same-origin for local tooling). That is
 * a localhost-only convenience and must not be mirrored here.
 */
export const PLUGIN_IFRAME_SANDBOX =
  'allow-scripts allow-forms allow-downloads allow-popups allow-popups-to-escape-sandbox';
